import {
  ticketList,
  ticketByUuid,
  ticketUpdate,
  ticketAssign,
  ticketClose,
  ticketReopen,
  ticketReply,
  staffList,
} from '@/services/supportTickets.service'

export default {
  namespaced: true,

  state: {
    ticketList: { data: [], meta: { pagination: { total: 0 } } },
    ticketListStatus: 'init',

    currentTicket: null,
    currentTicketStatus: 'init',

    staffOptions: [],
    staffOptionsStatus: 'init',
  },

  getters: {
    getTicketList: state => state.ticketList,
    getTicketListStatus: state => state.ticketListStatus,

    getCurrentTicket: state => state.currentTicket,
    getCurrentTicketStatus: state => state.currentTicketStatus,

    getStaffOptions: state => state.staffOptions,
    getStaffOptionsStatus: state => state.staffOptionsStatus,
  },

  mutations: {
    SET_TICKET_LIST(state, payload) { state.ticketList = payload },
    SET_TICKET_LIST_STATUS(state, status) { state.ticketListStatus = status },

    SET_CURRENT_TICKET(state, payload) { state.currentTicket = payload },
    SET_CURRENT_TICKET_STATUS(state, status) { state.currentTicketStatus = status },

    SET_STAFF_OPTIONS(state, payload) { state.staffOptions = payload },
    SET_STAFF_OPTIONS_STATUS(state, status) { state.staffOptionsStatus = status },
  },

  actions: {
    // ── Tickets ───────────────────────────────────────
    async fetchTicketList({ commit }, params) {
      commit('SET_TICKET_LIST_STATUS', 'pending')
      try {
        const { data } = await ticketList(params)
        commit('SET_TICKET_LIST', data)
        commit('SET_TICKET_LIST_STATUS', 'init')
        return data
      } catch (error) {
        commit('SET_TICKET_LIST_STATUS', 'error')
        throw error
      }
    },

    async fetchTicket({ commit }, uuid) {
      commit('SET_CURRENT_TICKET_STATUS', 'pending')
      try {
        const { data } = await ticketByUuid(uuid)
        commit('SET_CURRENT_TICKET', data.data)
        commit('SET_CURRENT_TICKET_STATUS', 'init')
        return data
      } catch (error) {
        commit('SET_CURRENT_TICKET_STATUS', 'error')
        throw error
      }
    },

    async updateTicket(_, { uuid, payload }) {
      const { data } = await ticketUpdate(uuid, payload)
      return data
    },

    async assignTicket(_, { uuid, payload }) {
      const { data } = await ticketAssign(uuid, payload)
      return data
    },

    async closeTicket(_, uuid) {
      const { data } = await ticketClose(uuid)
      return data
    },

    async reopenTicket(_, uuid) {
      const { data } = await ticketReopen(uuid)
      return data
    },

    // ── Messages ──────────────────────────────────────
    async replyToTicket(_, { uuid, payload }) {
      const { data } = await ticketReply(uuid, payload)
      return data
    },

    // ── Staff ─────────────────────────────────────────
    async fetchStaffOptions({ commit }, params) {
      commit('SET_STAFF_OPTIONS_STATUS', 'pending')
      try {
        const { data } = await staffList(params)
        commit('SET_STAFF_OPTIONS', data.data || [])
        commit('SET_STAFF_OPTIONS_STATUS', 'init')
        return data
      } catch (error) {
        commit('SET_STAFF_OPTIONS_STATUS', 'error')
        throw error
      }
    },
  },
}
